module.exports = __webpack_public_path__ + "static/media/noorders.fc3ff753.png";